export default __webpack_public_path__ + "static/media/detail.ab4a952c.svg";